// @ts-nocheck
/*
 * Port of views/dashboard/ivr/IVR/provider/IvrContext.js (16 lines).
 * BYTE-IDENTICAL.
 */
import { createContext } from 'react';

export const NodesContext = createContext({
  nodes: [],
  audioList: [],
  apiPath: '',
  nodeConnections: {},
  setNodes: () => {},
  smsWebhookFlag: false,
  smsWebhookList: [],
  webhookList: [],
  apiWebhookList: [],
  flowVariablesList: [],
  flowOperatorsList: [],
  updateNodeData: () => {},
  onRemove: () => {},
} as any);
